module.exports = __webpack_public_path__ + "static/media/trash.7fe3336e.svg";